<template>
  <font-awesome-layers @click="e => $emit('click', e)">
    <font-awesome-icon icon="circle" :size="size" :class="textColor" />
    <font-awesome-icon
      :transform="transform"
      :icon="icon"
      :size="size"
      inverse
      v-bind:class="getCssClasses"
    />
  </font-awesome-layers>
</template>

<script>
import { FontAwesomeLayers } from '@fortawesome/vue-fontawesome';

export default {
  name: 'RoundIconButton',
  props: {
    icon: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: '2x',
    },
    transform: {
      type: String,
      required: false,
      default: 'shrink-6',
    },
    cssClasses: {
      type: Array,
      default: () => [],
    },
    textColor: {
      type: String,
      default: 'text-black-25',
    },
  },
  computed: {
    getCssClasses() {
      return [{ active: this.active }, ...this.cssClasses];
    },
  },
  components: {
    FontAwesomeLayers,
  },
};
</script>

<style scoped>
div {
  cursor: pointer;
}
</style>
